import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgPersonFilled = function SvgPersonFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.51472 2 7.5 4.01472 7.5 6.5 7.5 8.98528 9.51472 11 12 11 14.4853 11 16.5 8.98528 16.5 6.5 16.5 4.01472 14.4853 2 12 2ZM12.0014 12.5C8.27968 12.5 5.43692 14.7258 4.28043 17.8527 3.97401 18.6813 4.18231 19.4953 4.67127 20.078 5.14989 20.6484 5.89317 21 6.69823 21H17.3046C18.1096 21 18.8529 20.6484 19.3315 20.078 19.8205 19.4953 20.0288 18.6813 19.7223 17.8527 18.5659 14.7258 15.7231 12.5 12.0014 12.5Z"
  })));
};

export { SvgPersonFilled as ReactComponent };
//# sourceMappingURL=person-filled.svg.js.map
